/**
 * Styled Components - Created by david on 26/02/18.
 */
import styled from 'styled-components'
import { GRAY_DARK, WHITE } from '../../../theme/colors'
import { Icon } from 'antd'

interface StyledProps {
  showLeftTabs?: boolean
}

export const Container = styled.div`
  font-family: Avenir;
  background-color: ${WHITE};
  box-shadow: 0 1px 0px rgba(0, 0, 0, 0.12), 0 0px 2px rgba(0, 0, 0, 0.24);
  width: ${({ showLeftTabs }: StyledProps) => showLeftTabs ? '0px' : '100%'};
  max-width: 470px;
  z-index: 1;
  position: relative;

  & .ant-tabs-nav .ant-tabs-tab {
    margin: 0; /* 8px; removing this margin to make all item fit */
    padding: 12px;
  }

  & .ant-tabs-nav-wrap {
    display: flex;
    justify-content: center;
    background-color: #000000;
    height: 63px;
  }

  & .ant-tabs-ink-bar {
    background-color: #C91731;
    height: 3px;
    bottom: 5px !important;
  }

  .ant-tabs-bar {
    margin-bottom: 0px;
  }

  .ant-tabs-nav-container-scrolling {
    padding-left: 0px;
    padding-right: 0px;
  }

  .ant-tabs-tab-next {
    display: none !important;
  }

  .ant-tabs-nav-container .ant-tabs-nav-container-scrolling:after {
    display: none !important;
  }

  .ant-tabs-tab-prev, .ant-tabs-tab-disabled {
    display: none !important;
  }

  .ant-tabs-content {
    height: calc(100vh - 143px);
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
    width: ${({ showLeftTabs }: StyledProps) => showLeftTabs ? '0%' : '35%'};
  }

  @media only screen and (min-device-width: 1366px) and (max-device-width: 1366px) and (orientation: landscape) {
    width: ${({ showLeftTabs }: StyledProps) => showLeftTabs ? '0%' : '28%'};
  }

  @media (min-height: 800px) {
    height: 92vh;
  }
  
  @media (min-width: 768px) and (max-width: 991px) {
    & .ant-tabs-tab-prev,
    & .ant-tabs-tab-next {
      display: none;
    }
    & .ant-tabs-nav-container {
      overflow: initial;
      padding: 25px 0px;
      white-space: initial;
    }
    & .ant-tabs-nav {
      display: flex;
      justify-content: space-between;
    }
  }

  @media (min-width: 2024px) {
    height: 100%;
  }

  transition: width 0.35s ease-in-out;
  animation: fade-in-top-toolbar-left 0.35s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-top-toolbar-left {
    0% {
      transform: translateY(-20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const HideLeftTabsButton = styled.div`
  text-align: center;
  color: #797979;
  background: whitesmoke;
  width: fit-content;
  font-weight: 600;
  padding: 4px 22px;
  padding-top: 6px;
  position: absolute;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  transform: rotate(-90deg);
  cursor: pointer;
  top: 50vh;
  right: -47px;
  box-shadow: 0px 0px 0px 1px rgba(192, 192, 192, 0.2);
`

export const StyledIcon = styled(Icon)`
  color: #6a6a6a;
  font-size: 15px;
  margin-right: 5px;
  margin-bottom: 2px;
`

export const Row = styled.div`
  width: 100%;
  margin-top: 20px;
  #title {
    color: ${GRAY_DARK};
    font-size: 22px;
    font-weight: 500;
    line-height: 100%;
  }
  #subtitle {
    color: #5F6062;
    font-size: 14px;
    font-weight: bold;
    line-height: 19px;
    font-family: Avenir;
    margin-top: 14px;
    :hover {
      cursor: pointer;
      color: cornflowerblue;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/Tabs/styledComponents.tsx